import PaginationRequestData from '@/calendesk/models/DTO/Request/PaginationRequestData'

export default class BookingFiltersRequestData extends PaginationRequestData {
  public service_ids: string | null = null
  public employee_ids: string | null = null
  public from: string | null = null
  public to: string | null = null
}
